import { makeAutoObservable } from 'mobx';
import _ from 'lodash';
import moment from 'moment';

class FeedItemsState {
  feedItems;
  nextLink;
  loadMore;
  feedState;

  constructor() {
    makeAutoObservable(this);
  }

  receiveProps({feedItems, nextLink, loadMore, feedState}) {
    this.feedItems = feedItems;
    this.nextLink = nextLink;
    this.loadMore = loadMore;
    this.feedState = feedState;
  }

  async load() {
    await this.loadMore();
  }

  get sortedFeedItems() {
    return _.orderBy(this.feedItems, 'publishedAt', 'desc');
  }

  get pinnedFeedItems() {
    return _.orderBy(_.filter(this.sortedFeedItems, 'pinned'), 'pinnedAt', 'asc');
  }

  get currentFeedItems() {
    return _.filter(this.sortedFeedItems, feedItem => {
      return !feedItem.pinned && moment(feedItem.publishedAt).isSameOrAfter(moment().subtract(7, 'days'), 'day');
    });
  }

  get olderFeedItems() {
    return _.filter(this.sortedFeedItems, feedItem => {
      return !feedItem.pinned && moment(feedItem.publishedAt).isSameOrBefore(moment().subtract(8, 'days'), 'day');
    });
  }
}

export default FeedItemsState;
